import { render, staticRenderFns } from "./MonthList.vue?vue&type=template&id=1971f025&lang=pug&"
import script from "./MonthList.vue?vue&type=script&lang=ts&"
export * from "./MonthList.vue?vue&type=script&lang=ts&"
import style0 from "./MonthList.vue?vue&type=style&index=0&id=1971f025&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports